<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--welcomeback" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_modals_resubscribe_confirmation_you_are_not_subscribed }}</h1>
          <!--h2>$#Your points: <span class="points">XXX</span></h2>
          <h2>$#Your level: <span class="level">Y</span></h2-->
          <img :src="getTranslations.project_config_modal_img" alt="">
        </div>
        <div class="modal__body">
          {{ getTranslations.home_modals_resubscribe_confirmation_in_order_to_unlock }}
        </div>
        <div class="modal__footer">
          <a style="cursor:pointer" class="btn2 btn2--std btn2--small" @click.prevent="reOptin">
              {{ getTranslations.home_modals_resubscribe_confirmation_resubscribe }}
          </a>
          <span class="terms">
          {{ getTranslations.home_modals_resubscribe_confirmation_by_clicking }}
          <br>
          <a style="cursor:pointer" :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.home_modals_resubscribe_confirmation_t_and_cs }}</a>
          {{ getTranslations.home_modals_resubscribe_confirmation_of_the_service }}
        </span>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import modals from '../../../common/modals';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';
import ResubscribeViaPin from './ResubscribeViaPin';
import ResubscribeError from './ConfirmPurchaseForPinError';

export default {
  // modal_unsubscribe_newgame_store.html
  name: 'resubscribe-game',
  mixins: [IntegrationMixin],
  data() {
    return {
      showedModal: false,
    };
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForStore',
      'storeModalForHomePage',
    ]),
    ...mapActions('common', [
      'reOptinProcess',
    ]),
    showResubModal(modal) {
      if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
        this.storeModalForStore(modal);
      } else {
        this.storeModalForHomePage(modal);
      }
      modals.showHideModalForHomeStorePage(this);
    },
    reSubCallback(response) {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        this.getUserLoginDetails().then(() => {
          if (this.reoptinOnestep) {
            if (this.userDetails.subscribed) {
              this.showResubModal(WelcomeReturningUnsub);
            } else {
              this.showResubModal(ResubscribeError);
            }
          } else {
            // eslint-disable-next-line
            if (!this.userDetails.subscribed) {
              this.showResubModal(ResubscribeViaPin);
            } else {
              this.showResubModal(ResubscribeError);
            }
          }
        });
      } else {
        this.showResubModal(ResubscribeError);
      }
    },
    reOptin() {
      // eslint-disable-next-line
      console.log('Resubscribe user Call');
      this.getAppropriateReSubAction();
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'reoptinOnestep',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeGame.vue